// src/index.ts
var SIEBEL_SESSION_EXPIRED_CODE = "SIEBEL_SESSION_EXPIRED";
export {
  SIEBEL_SESSION_EXPIRED_CODE
};
//# sourceMappingURL=index.mjs.map